import { render, staticRenderFns } from "./snUpdate.vue?vue&type=template&id=5896b230&scoped=true&"
import script from "./snUpdate.vue?vue&type=script&lang=js&"
export * from "./snUpdate.vue?vue&type=script&lang=js&"
import style0 from "./snUpdate.vue?vue&type=style&index=0&id=5896b230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5896b230",
  null
  
)

export default component.exports